import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

interface PostLoginBody {
  email: string;
  password: string;
}

export const MoodsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMoods: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        start?: number;
        length?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.moods}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    getMoodById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.moods}/${id}/`,
        method: "GET",
      }),
    }),
    updateMood: builder.mutation<CommonResponseType, { body: any; id: number }>(
      {
        query: ({ body, id }) => ({
          url: `${END_POINTS.updateMoods}${id}/`,
          method: "PUT",
          body,
        }),
      }
    ),
    userAction: builder.mutation<CommonResponseType, { body: any; id: number }>(
      {
        query: ({ body, id }) => ({
          url: `${END_POINTS.moods}/${id}`,
          method: "PATCH",
          body,
        }),
      }
    ),
    deleteMood: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteMoods}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useUserActionMutation,
  useLazyGetMoodsQuery,
  useLazyGetMoodByIdQuery,
  useUpdateMoodMutation,
  useDeleteMoodMutation,
} = MoodsApi;
